// Tiny shared flag for the page-load intro: the hero (and smooth scroll) wait for it.
let done = false;
const listeners = new Set();

export const isIntroDone = () => done;

export function finishIntro() {
  if (done) return;
  done = true;
  listeners.forEach((cb) => cb());
  listeners.clear();
}

/** Runs `cb` once the intro has finished (right away if it already has). Returns an unsubscribe. */
export function onIntroDone(cb) {
  if (done) {
    cb();
    return () => {};
  }
  listeners.add(cb);
  return () => listeners.delete(cb);
}
